import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild
} from '@angular/core';
import {CalEvent} from "../utils/model/CalEvent";
import {ModalDirective} from "ngx-bootstrap/modal";

declare let $: any;

@Component({
  selector: 'calendar-dialog-delete',
  templateUrl: './dialog-delete.component.html',
  styleUrls: ['./dialog-delete.component.scss']
})
export class CalendarDialogDelete implements AfterViewInit, OnDestroy {
  @Input() calEvent?: CalEvent;
  @Output() onDelete = new EventEmitter<any>();
  @ViewChild(ModalDirective) confirmDialog!: ModalDirective;
  @ViewChild('dialogDelete') dialogDelete!: ElementRef;
  @Output() onLoad = new EventEmitter<any>();

  dialogTitle: string = 'Lịch công tác';
  dialogContent: string = '';

  private _$dialogDelete: any;

  constructor() {
  }

  ngAfterViewInit(): void {
    this._initDialogDelete();
  }

  ngOnDestroy(): void {
    this._destroyDialogDelete();
  }

  hide() {
    this.confirmDialog.hide();
  }

  delete() {
    if (this.calEvent) {
      this.onDelete.emit({
        element: this.calEvent.uuid,
        orgid: this.calEvent.firmUUID
      });
    }
  }

  show() {
    if (this.calEvent) {
      this.dialogContent = 'Bạn có đồng ý xóa sự kiện <b>"' + this.calEvent.subject + '"</b> không?';
      this.confirmDialog.show();
    }
  }

  private _initDialogDelete() {
    this._$dialogDelete = $(this.dialogDelete.nativeElement).hide();

    // Click outside to close
    this.hide = this.hide.bind(this);
    document.body.addEventListener('click', this.hide);

    // Prevent close
    this._$dialogDelete.on('click', (e: any) => e.stopPropagation());

    // Append modal to body
    $(document.body).append(this._$dialogDelete);
  }

  private _destroyDialogDelete() {
    document.body.removeEventListener('click', this.hide);
    this._$dialogDelete.remove();
  }
}
